// extracted by mini-css-extract-plugin
export default {"login":"Login_login__rDu75","form":"Login_form__aKe28","logo":"Login_logo__50KVm","loginButton":"Login_loginButton__9fbiE"};